import React from 'react';
import { categoriesData } from '../Home/categoriesData';
import ValuationSnapshot from './ValuationSnapshot';
import MultiLineValuationSnapshot from './MultiLineValuationSnapshot';
import { PlanStatusTilesGrid } from './PlanStatusTile';
import DealRoomMetricsCard from './DealRoomMetricsCard';
import { SnackbarProvider } from 'notistack';
import SuccessionThemeProvider from './SuccessionThemeProvider';
import SuccessionDrawerWithListener from '../../containers/Succession/SuccessionDrawerWithListener';
import { CategoryTemplate, ToolsGridTemplate } from '../../../../ui/layouts';
import ProfileCompletionCard from './ProfileCompletionCard';
import { Anchor } from 'lucide-react';

const SuccessionExplorerContent = () => {
  return (
    <PlanStatusTilesGrid showHeaderIcon={false}>
      {/* Deal Room Card - included in the same 2-column grid */}
      <DealRoomMetricsCard showHeaderIcon={false} />
    </PlanStatusTilesGrid>
  );
};

const SuccessionCategoryPage = (props) => {
  const name = (props?.current_user && props.current_user.name) || (typeof document !== 'undefined' && document.store?.getState?.()?.user?.name) || 'there';
  const features = props?.features || (props?.company && (props.company.feature_types || props.company.features)) || [];
  const multiLineValuationEnabled = Array.isArray(features) && features.includes('multi_line_valuation');
  // Derive tools for the growth category (used in sidebar tools grid)
  const cat = (categoriesData || []).find((c) => c.id === 'succession');
  const tools = (cat && cat.tools) || [];

  return (
    <>
      <CategoryTemplate
        title="Explore Succession"
        variant="wide"
        hero={{
          title: 'Succeed at Succession',
          blurb: 'Create a practical strategy for continuity, emergencies, and deal readiness. Track your progress, understand your valuation, and take the next best step toward transition.',
          ctaHref: '/succession/education?category=Value%20Acceleration',
          ctaLabel: 'Learn more about Succession',
          variant: 'brand',
          icon: Anchor,
        }}
        sidebar={(
          <>
            <ProfileCompletionCard elevateOnHover={false} className="mb-4" />
            {multiLineValuationEnabled ? (
              <MultiLineValuationSnapshot showHeaderIcon={false} compact className="mb-4" />
            ) : (
              <ValuationSnapshot showHeaderIcon={false} compact className="mb-4" />
            )}
            <ToolsGridTemplate title="Popular Tools" tools={tools} />
          </>
        )}
      >
        <SuccessionExplorerContent />
      </CategoryTemplate>

      <SnackbarProvider maxSnack={3}>
        <SuccessionThemeProvider company={props.company} user={props.current_user}>
          <SuccessionDrawerWithListener />
        </SuccessionThemeProvider>
      </SnackbarProvider>
    </>
  );
};

export default SuccessionCategoryPage;